import profile from "common/icons/profile.svg";
import React from "react";

interface ProfileProps {
  name: string;
  description: string;
  imageUrl?: string;
}

export const ProfilePage: React.FC<any> = ({ scrollToSection }) => {
  return (
    <section className="w-full overflow-hidden  bg-white " id="home">
      <div className=" mb-32 flex flex-col w-full items-start justify-between px-4 py-10 md:flex-row md:py-20 md:px-8 lg:px-16 max-w-7xl">
        {/* Text Column */}
        <div className="w-full mt-10  md:w-[90%] md:pr-8">
          <h3 className="text-[#9d9d9d]  text-2xl font-semibold tracking-wide">HI THERE!</h3>
          <div className="flex ">
            <h1 className="mt-1 md:mt-3  text-3xl md:text-4xl lg:text-[60px] font-bold text-gray-800">I&rsquo;M </h1>
            <div className="2xl:text-[49px] xl:mt-6 lg:mt-2 mt-3  xl:text-[40px] lg:text-[80px] md:text-[40px]  text-[25px] font-bold   ml-2  ">
              <span
                className="bg-clip-text text-transparent bg-white"
                style={{
                  WebkitTextStroke: "2px #FFB800",
                  fontSize: "60px",
                }}
              >
                DEVA P. SEETHARAM
              </span>
            </div>
          </div>
          <p className="mt-10 text-[20px] text-[#454444] tracking-[1px] leading-[35px] text-justify md:text-start  w-[100%] mb-12 ">
            An accomplished leader with deep technical skills for designing innovative solutions and soft skills for
            commercializing those innovations. Co-founded and led 2 successful technology startups and a successful
            research group for IBM Research India. Have been granted 21 US patents and have published more than 50
            papers in top academic venues. Have client and business development experience in USA, Australia, Europe and
            India.
          </p>
          <button
            onClick={() => scrollToSection("about")} // Scroll to the "about" section
            type="button"
            className="  rounded-xl text-[25px] bg-[#293855] px-[120px] py-[20px] md:flex justify-center align-middle text-center flex text-white hover:bg-secondary-color"
          >
            More About Me
          </button>
        </div>

        {/* Image Column + Orange Outline */}
        <div className="flex justify-center md:justify-end md:w-1/2 ">
          <div className="relative inline-block">
            <div className="absolute  hidden md:block w-full  2xl:w-[192%] left-4 md:h-[80%] border-4 border-primary-color z-10"></div>
            <img
              src={profile}
              alt="Profile"
              className="relative z-10 object-cover 2xl:left-[11.5rem]  md:mt-10 w-64 h-auto lg:w-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
